<form [formGroup]="validateForm" (ngSubmit)="validateRecoveryCode()">
  <h3>{{ "i18n.base.two-factor-authentication.step-verify-recovery-code.header" | translate }}</h3>
  <div class="form-group">
    <p>{{ "i18n.base.two-factor-authentication.step-verify-recovery-code.description" | translate }}</p>
  </div>
  <div class="form-group">
    <label for="token">{{ "i18n.base.two-factor-authentication.step-verify-recovery-code.recovery-code" | translate }}</label>
    <input id="token" type="text" class="form-control" placeholder="{{ 'i18n.base.two-factor-authentication.step-verify-recovery-code.recovery-code' | translate }}"
      formControlName="recoveryCode">
    <app-error-messages [control]="validateForm.controls.recoveryCode"></app-error-messages>
  </div>
  <button type="submit" class="btn btn-primary btn-right" [disabled]="loading">
    {{ "i18n.base.two-factor-authentication.step-verify-recovery-code.verify" | translate }}
  </button>
</form>
